<template>
    <div>
        <navigation></navigation>
        <div class="gd_main w_1000">
            <!--页面位置指示-->
            <div class="gdErji_position">
                <span class="gdErji_position_ico"></span>
                <div class="gdErji_position_text">您现在的位置：<span>联系我们</span></div>
            </div>

            <div class="gdsanji_box">
                <div class="gdsj_title">河北基层卫生协会</div>
                <div class="gd_contUs" style="font-size: 16px;">
                    <p style="line-height: 30px;"><strong>办公电话Tel：</strong>0311-66165621</p>
                    <p style="line-height: 30px;padding-bottom: 10px;"><strong>地址：</strong>石家庄市高新区昆仑大街55号</p>
                    <p style="line-height: 30px;text-align: center;"><img src="../assets/img/weixingongzhonghao.jpg" width="350" height="350" alt="河北基层之家"><br><strong>微信公众号：</strong>河北基层之家</p>
                </div>
            </div>
        </div>
        <footer1></footer1>
    </div>
</template>

<script>
    import  navigation from '../components/Navigation';
    import  footer1 from '../components/Footer1';

    export default {
        name: 'index',
        components: {
            footer1,
            navigation
        },
        data () {
            return {

            }
        },

        mounted () {

        },
        methods: {

        }
    }
</script>
